import {
  BIOMES,
  type BiomeId,
  type BountyClaimed,
  type BountyRejected,
  type BountyState,
} from '@shefira/shared';

import { contractRewardLine } from './contract-text.js';
import { uiFormat, uiText } from './text.js';

/**
 * The words of the wanted boards (ADR 0096): a line per refusal of the
 * server, the state of a bounty, what a claim paid. French with its
 * accents; the DOM strips them (`uiText`).
 */

export const BOUNTY_REFUSAL_LINES: Readonly<Record<BountyRejected['reason'], string>> = {
  invalid: 'Cette prime n’est plus au tableau.',
  far: 'Approche-toi du tableau.',
  level: 'Tu n’as pas encore le niveau de cette région.',
  hunting: 'Une autre de tes cibles t’attend déjà : abats-la d’abord.',
  'no-room': 'La bête ne trouve pas où se montrer : réessaie dans un instant.',
  'not-done': 'La bête court toujours : abats-la avant de toucher la prime.',
  claimed: 'Tu as déjà touché cette prime.',
  'bag-full': 'Ton sac est plein : fais-y de la place pour la récompense.',
  busy: 'Un instant…',
};

/** The refusal in words; under the region's band, which level it takes. */
export function bountyRefusalText(rejected: BountyRejected, biome: BiomeId | undefined): string {
  if (rejected.reason === 'level' && biome !== undefined) {
    return uiFormat('Il faut le niveau {level} pour les primes de cette région.', {
      level: BIOMES[biome].level.min,
    });
  }
  return uiText(BOUNTY_REFUSAL_LINES[rejected.reason]);
}

/** Under a bounty's notice: where it stands in the hunt. */
export const BOUNTY_STATE_LINES: Readonly<Record<BountyState, string>> = {
  open: 'À prendre',
  out: 'En chasse : la bête t’attend',
  done: 'Abattue : la prime t’attend',
  claimed: 'Touchée',
};

export function bountyStateText(state: BountyState): string {
  return uiText(BOUNTY_STATE_LINES[state]);
}

/** The line of the chat once the board paid. */
export function bountyClaimedText(claimed: BountyClaimed): string {
  return uiFormat('Prime touchée : {reward}.', { reward: contractRewardLine(claimed) });
}
